module.exports = __webpack_public_path__ + "static/the-paypal-wars-2c9c4ad5ae96eed7e1bc4296281c96c4.jpg";